// Original restrained wordmark: stacked bars + "ThinkStack" set in the serif face.
export function Wordmark({ className = "", light = false, showMark = true }) {
  const ink = light ? "#FFFFFF" : "#0B1B34";
  const accent = "#3F67A3";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} aria-label="ThinkStack">
      {showMark && (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" aria-hidden="true">
          <rect x="2" y="15.5" width="22" height="3.2" fill={ink} />
          <rect x="4.5" y="10" width="17" height="3.2" fill={accent} />
          <rect x="7" y="4.5" width="12" height="3.2" fill={ink} />
        </svg>
      )}
      <span
        className="font-serif font-semibold tracking-tight leading-none"
        style={{ color: ink, fontSize: "1.42rem" }}
      >
        Think<span style={{ color: accent }}>Stack</span>
      </span>
    </span>
  );
}
